import axios from 'axios';
import config from '../config';

export const getContainerVersions = (): Promise<string[]> => {
    return axios.get(`${config.API_URL}/system/container-versions`).then((response: any) => {
        return response.data.data.containerVersions;
    });
};
